import React from "react";

import dateString from "helpers/dateString";
import possessiveString from "helpers/possessiveString";

import Button from "components/Button";

import FollowCaseIntro from "components/FollowCaseIntro";
import Icon from "components/Icon";
import Share from "components/Share";
import bestDate from "helpers/bestDate";

import { useUser } from "@auth0/nextjs-auth0/client";

import IconCalendar from "assets/svgs/calendar.svg";
import IconPin from "assets/svgs/pin.svg";
import IconPlus from "assets/svgs/plus.svg";

export default function Intro({
  addOutsetaUserCaseList,
  outsetaUserId,
  outsetaUserCaseList,
  slug,
  victim,
  victimName,
  contributePanelVisible,
  setContributePanelVisible,
  setSignupOpen,
}) {
  const { user } = useUser();
  const customFirstName = victimName.split(" ")[0];

  const {
    city,
    classification,
    dateFound,
    dateOfDeath,
    dateMissing,
    dateLastUpdated,
    shortDescription,
    state,
    primaryImageUrl,
  } = victim;



  const shareContent = {
    shareUrl: `https://uncovered.com/cases/${slug}`,
    quote: `What happened to ${victimName}?`,
    hashtag: "#uncovered",
  };

  const whoseCase = (classification !== "Unidentified Person") ? possessiveString(customFirstName) : "This";

  return (
    <div className="flex justify-center mx-auto w-full">
      <div className="flex max-w-6xl w-full z-10 gap-4 lg;gap-10 p-4">
        <div className="flex-shrink-0">
          {typeof primaryImageUrl === "string" ? (
            <figure className="relative md:pb-4">
              <img 
                className="border-4 border-white md:w-[320px]"
                src={primaryImageUrl}
                width="110"
              />
            </figure>
          ) : (
            <figure className="relative md:pb-4">
              <img
                className="border-4 border-white md:w-[320px]"
                src="https://imagedelivery.net/uavUKOC7HZo0CRGpx2We4A/7bf49a2a-7489-40fc-7ffc-509b28771700/public"
                width="110"
              />
            </figure>
          )}
        </div>

        <div className="flex flex-col justify-between w-full">
          <div className="flex flex-col">
            <span className="font-semibold text-xs uppercase text-yellow-400 md:text-xl">
              {classification}
            </span>
            <h1 className="mt-1 text-xl	md:text-5xl">{victimName}</h1>
            <div className="flex">
              {outsetaUserId !== "" ? (
                <div className="mt-3 sm:flex items-center">
                  <FollowCaseIntro
                    addOutsetaUserCaseList={addOutsetaUserCaseList}
                    outsetaUserCaseList={outsetaUserCaseList}
                    outsetaUserId={outsetaUserId}
                    slug={slug}
                    buttonHeight="32"
                    buttonStyle
                    customFirstName={customFirstName}
                  />
                  <Share shareContent={shareContent} className="mt-4 sm:ml-4 sm:mt-0" />
                </div>
              ) : (
                <div className="sm:flex items-center mt-3">
                  <Button
                    id="follow-case-btn"
                    emphasis="primary"
                    height="32"
                    onClick={() => setSignupOpen(true)}
                  >
                    <IconPlus className="mr-1" width="8" /> Follow{" "}
                    {whoseCase} Case
                  </Button>

                  <Share shareContent={shareContent} className="mt-4 sm:ml-4 sm:mt-0" />                 
                </div>
              )}
            </div>
            <p
              className=" pl-4 py-6 -ml-36 md:ml-0"
            >
              {shortDescription && shortDescription}
            </p>
          </div>

          <div className=" flex justify-between items-start -ml-36 md:ml-0 lg:items-end pl-4 pb-8 flex-col lg:flex-row ">
            <ul className="text-gray-500 mt-4 text-sm">
              {dateLastUpdated && (
                <li className="text-black text-sm">
                  Last updated: {dateString(dateLastUpdated)}
                </li>
              )}
              {city && (
                <li className="flex items-center mt-4">
                  <Icon className="flex justify-center mr-3 text-gray-400 w-5">
                    <IconPin height="20" width="14" />
                  </Icon>{" "}
                  {city}
                  {state && <>, {state}</>}
                </li>
              )}
              {(dateMissing || dateOfDeath || dateFound) && (
                <li className="flex items-center mt-4">
                  <Icon className="flex justify-center mr-3 text-gray-400 w-5">
                    <IconCalendar height="20" width="18" />
                  </Icon>
                  {dateString(bestDate(dateMissing, dateOfDeath, dateFound))}
                </li>
              )}
              <li></li>
            </ul>
            {!user ? (
              <Button
                emphasis="primary"
                height="32"
                onClick={() => setSignupOpen(true)}
                className="bg-yellow-400 rounded-md mt-5 font-bold text-white py-2 px-5 text-sm top-0 right-0"
              >
                Contribute to {whoseCase} Case
              </Button>
            ) : (
              <Button
                className="bg-yellow-400 rounded-md mt-5 font-bold text-white py-2 px-3 text-sm top-0 right-0"
                type="button"
                onClick={() => setContributePanelVisible(!contributePanelVisible)}
              >
                Contribute to {whoseCase} Case
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
